import type { FlagConfiguration } from '@atlassian/jira-flags'; // ignore-for-ENGHEALTH-17759
import messages from './messages.tsx';

export const START_DATE_MISSING_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.startDateMissingErrorTitle,
	description: messages.startDateMissingErrorMessage,
};

export const SCHEDULE_ITEM_FAIL_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.scheduleItemErrorTitle,
	description: messages.scheduleItemErrorDescription,
};

export const SCHEDULE_ITEM_NOT_FOUND: FlagConfiguration = {
	type: 'error',
	title: messages.scheduleItemNotFound,
	description: messages.scheduleItemRemoved,
};

export const SCHEDULE_ITEM_NOT_FOUND_ISSUE_TERM_REFRESH: FlagConfiguration = {
	type: 'error',
	title: messages.scheduleItemNotFoundIssueTermRefresh,
	description: messages.scheduleItemRemovedIssueTermRefresh,
};
